import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  LoadingController,
  ModalController,
} from "ionic-angular";

import { ParticipacaoProvider } from "../../providers/participacao/partipacao.provider";
import { Participacao } from "../../domain/participacao";

import { ResiduoProvider } from "../../providers/reciclagem/residuo.provider";

import { ReciclagemProvider } from "../../providers/reciclagem/reciclagem.provider";
import { ReciclagemReciboPage } from "./reciclagem-recibo/reciclagem-recibo";
import { ReciclagemOrigemPage } from "./reciclagem-origem/reciclagem-origem";
import { ContratoProvider } from "../../providers/contrato/contrato.provider";
import { AnonymizeProvider } from "../../providers/anonymize/anonymize.provider";
import { VeiculoProvider } from "../../providers/veiculo/veiculo.provider";

@IonicPage({
  name: "page-reciclagem",
  segment: "page-reciclagem/:id",
})
@Component({
  selector: "page-reciclagem",
  templateUrl: "reciclagem.html",
})
export class ReciclagemPage {
  evento_aberto: any;

  cec_id: any; //ClienteEventoContrato (ID) || Participacao (ID)
  participante: Participacao | false = false;

  residuosAvaiable: any | false = false;
  residuoOnSelected: any | false = false;
  residuosAdded: Array<any> = [];

  inputPeso: number;

  showInputPeso: boolean = false;
  showResiduosAdded: boolean = false;

  infoReciclagem: any | false = false;

  instituicao = false;
  contratoOrigemId = null;

  // Novas propriedades para seleção de doador
  possuiDoador: boolean = false;
  contratoDoadorSelecionado: any = null;
  modalDoadorAberto: boolean = false;

  // ECOENEL-217: Veículo obrigatório
  veiculoObrigatorio: boolean = false;
  veiculos: any[] = [];
  veiculoSelecionado: any = null;

  // Getter reativo: doador obrigatório para itinerante (não-instituição)
  get doadorPendente(): boolean {
    if (this.instituicao) return false;
    if (!this.evento_aberto || !this.evento_aberto.itinerante) return false;
    return !this.contratoDoadorSelecionado;
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public participacaoProvider: ParticipacaoProvider,
    public residuoProvider: ResiduoProvider,
    public reciclagemProvider: ReciclagemProvider,
    public alertCtrl: AlertController,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController,
    public contratoProvider: ContratoProvider,
    public anonymizeProvider: AnonymizeProvider,
    public modalCtrl: ModalController,
    public veiculoProvider: VeiculoProvider
  ) {
    this.cec_id = this.navParams.get("id");
    this.contratoOrigemId = this.navParams.get("origem");

    this.getParticipante();
    this.getEventoAberto();
    this.getResiduos();
  }

  adicionarResiduo() {
    if (!this.residuoOnSelected)
      return this.alertInfo("Selecione uma resíduo primeiro");
    if (this.inputPeso == undefined)
      return this.alertInfo("Informe o peso do resíduo");

    let load = this.loadCtrl.create({ content: "Adicionando resíduo..." });
    load.present();

    this.residuoOnSelected.quantidade = this.inputPeso;
    // Formula do arredondar (?)
    this.residuoOnSelected.bonus_valor =
      this.residuoOnSelected.quantidade * this.residuoOnSelected.valor;
    this.residuoOnSelected.bonus_valor = this.residuoOnSelected.bonus_valor.toFixed(
      2
    );

    this.residuosAdded.unshift({
      bonus_valor: this.residuoOnSelected.bonus_valor,
      medidoem: this.residuoOnSelected.medidoem,
      nome: this.residuoOnSelected.nome,
      quantidade: this.residuoOnSelected.quantidade,
      recurso_id: this.residuoOnSelected.recurso_id,
      valor: this.residuoOnSelected.valor,
      reciclador_id: this.residuoOnSelected.reciclador_id,
      vigencia_id: this.residuoOnSelected.vigencia_id,
      _novo: true,
    });

    // Remove flag de animação após o efeito
    setTimeout(() => { this.residuosAdded[0]._novo = false; }, 600);

    this.inputPeso = undefined;
    this.residuoOnSelected = false;
    this.showInputPeso = false;

    if (!this.showResiduosAdded) this.showResiduosAdded = true;
    this.infoReciclagem = this.getInfoTotal();

    load.dismiss();
  }

  getIconeResiduo(nome: string): string {
    if (!nome) return 'fas fa-recycle';
    const n = nome.toUpperCase();
    if (n.includes('PAPEL') || n.includes('JORNAL') || n.includes('PAPELÃO') || n.includes('PAPELAO'))
      return 'fas fa-newspaper';
    if (n.includes('PVC'))
      return 'fas fa-stream';
    if (n.includes('FILME'))
      return 'fas fa-receipt';
    if (n.includes('PET') || n.includes('PLÁSTICO') || n.includes('PLASTICO'))
      return 'fas fa-prescription-bottle';
    if (n.includes('ALUMÍNIO') || n.includes('ALUMINIO') || n.includes('LATA'))
      return 'fas fa-ring';
    if (n.includes('FERRO') || n.includes('AÇO') || n.includes('ACO') || n.includes('BRONZE'))
      return 'fas fa-wrench';
    if (n.includes('VIDRO'))
      return 'fas fa-wine-bottle';
    if (n.includes('TETRA') || n.includes('LONGA VIDA'))
      return 'fas fa-box';
    if (n.includes('ÓLEO') || n.includes('OLEO'))
      return 'fas fa-tint';
    return 'fas fa-recycle';
  }

  removerResiduoAdicionado(i: number) {
    const removido = this.residuosAdded[i];
    this.residuosAdded.splice(i, 1);
    this.alertInfo(`Removido: ${removido.nome} — ${removido.quantidade} ${removido.medidoem}`);
    this.infoReciclagem = this.getInfoTotal();
  }

  mostrarPeso() {
    this.showInputPeso = true;
  }

  salvarReciclagem() {
    // ECOENEL-217: Validar veículo obrigatório antes de salvar
    if (this.veiculoObrigatorio && !this.veiculoSelecionado) {
      this.alertInfo("Este evento exige a seleção de um veículo para registrar reciclagens");
      return;
    }

    // Validar doador obrigatório para eventos itinerantes
    if (this.doadorPendente) {
      this.alertInfo("Selecione um contrato doador para eventos itinerantes");
      return;
    }

    let load = this.loadCtrl.create({
      content: "Salvando reciclagem... Aguarde...",
    });
    load.present();

    // Determina o contrato_origem_id baseado na seleção
    let contratoOrigemFinal = null;

    // Se possui doador selecionado manualmente, usa ele
    if (this.possuiDoador && this.contratoDoadorSelecionado) {
      contratoOrigemFinal = this.contratoDoadorSelecionado.id;
    }
    // Se é instituição e tem origem definida (fluxo antigo)
    else if (this.instituicao && this.contratoOrigemId) {
      contratoOrigemFinal = this.contratoOrigemId;
    }
    // Caso contrário, é reciclagem própria (null)

    let reciclagem: any = {
      contrato_origem_id: contratoOrigemFinal,
      cliente_evento_contrato_id: this.cec_id,
      bonus_total: this.infoReciclagem.bonus_total,
      bonus_percentual: 100,
      residuos: this.residuosAdded,
    };

    // ECOENEL-217: Incluir veiculo_id se selecionado
    if (this.veiculoSelecionado) {
      reciclagem.veiculo_id = this.veiculoSelecionado;
    }

    this.reciclagemProvider
      .save(reciclagem)
      .then((success: any) => {
        this.residuosAdded = []
        reciclagem = {}
        this.infoReciclagem = false;

        load.dismiss();

        this.alertInfo(
          success.aplicativo && !success.notificacao
            ? "Reciclagem Realizada com Sucesso, Mas Não Foi Possível Enviar a Notificação Para o Celular"
            : "Reciclagem Realizada com Sucesso!"
        );

        this.navCtrl.push(ReciclagemReciboPage, {
          id: success.data.id,
          notificacao: success.notificacao,
          aplicativo: success.aplicativo,
        });


      })
      .catch((err) => {
        load.dismiss();
        console.log(err);
        let toast = this.toastCtrl.create({ duration: 1500 });
        toast.setMessage("Não foi possível salvar a reciclagem. ");
        toast.present();
      });
  }

  /* Privates */
  private getEventoAberto(): any {
    if (localStorage.getItem("evento_aberto")) {
      this.evento_aberto = JSON.parse(localStorage.getItem("evento_aberto"));

      // ECOENEL-217: Verificar flag veiculo_obrigatorio
      if (this.evento_aberto.veiculo_obrigatorio) {
        this.veiculoObrigatorio = true;
        this.carregarVeiculos();
      }

      // Itinerante: doador obrigatório — iniciar seção visível
      if (this.evento_aberto.itinerante) {
        this.possuiDoador = true;
      }

      return true;
    } else {
      let toast = this.toastCtrl.create({ duration: 1500 });
      let self = this;
      toast.setMessage("Selecione um evento antes de continuar!");
      toast.present();
      toast.onDidDismiss(() => {
        self.navCtrl.setRoot("HomePage");
      });
      return false;
    }
  }

  private carregarVeiculos() {
    this.veiculoProvider.getAtivos().subscribe(
      (result) => {
        this.veiculos = result;
      },
      (err) => {
        console.error("Erro ao carregar veículos", err);
      }
    );
  }

  private getParticipante() {
    let load = this.loadCtrl.create({ content: "Buscando cliente..." });
    load.present();
    this.participacaoProvider.getById(this.cec_id).subscribe((result) => {
      this.participante = result;
      if (
        result.contrato.instituicao_contrato &&
        result.contrato.instituicao_contrato.length > 0
      ) {
        this.instituicao = true;
        if (this.contratoOrigemId) {
          this.contratoProvider.getById(this.contratoOrigemId).subscribe({
            next: (contrato) => {
              console.log(contrato);
              load.dismiss();
            },
            error: () => {
              load.dismiss();
              let toast = this.toastCtrl.create({ duration: 1500 });
              let self = this;
              toast.setMessage("A origem selecionada não é valida");
              toast.present();
              toast.onDidDismiss(() => {
                self.selecionarOrigem();
              });
            },
          });
        } else {
          this.selecionarOrigem();
          load.dismiss();
        }
      } else {
        load.dismiss();
      }
    });
  }

  selecionarOrigem() {
    this.navCtrl.push(ReciclagemOrigemPage, { id: this.cec_id });
  }

  private getResiduos() {
    let load = this.loadCtrl.create({
      content: "Buscando resíduos recicláveis...",
    });
    load.present();
    this.residuoProvider
      .getResiduoAtivoByEventoId(this.evento_aberto.id)
      .subscribe((result) => {
        this.residuosAvaiable = result;
        load.dismiss();
      });
  }

  private getInfoTotal(): any {
    let peso_total = 0;
    let bonus_total = 0;

    if(!this.residuosAdded ||this.residuosAdded.length == 0) return false;

    this.residuosAdded.forEach(function (item, i) {
      peso_total += parseFloat(item.quantidade);
      bonus_total += parseFloat(item.bonus_valor);
    });

    return {
      peso_total: String(this.arredondar(peso_total)),
      bonus_total: String(this.arredondar(bonus_total)),
    };
  }

  private alertInfo(msg: string): void {
    let toast = this.toastCtrl.create({ duration: 2000 });

    toast.setMessage(msg);
    toast.present();
  }

  // Método para abrir o modal de busca de contrato doador
  abrirBuscaDoador() {
    // Só abre se o toggle estiver habilitado e modal não estiver aberto
    if (!this.possuiDoador || this.modalDoadorAberto) {
      return;
    }

    this.modalDoadorAberto = true;

    const modal = this.modalCtrl.create("contrato-search-modal", {
      excluirContratoId: this.participante && this.participante.contrato ? this.participante.contrato.id : null,
      titulo: "Selecionar Contrato Doador",
      excludeType: 4,
    });

    modal.onDidDismiss((data) => {
      this.modalDoadorAberto = false;
      if (data && data.selecionado && data.contrato) {
        this.contratoDoadorSelecionado = data.contrato;
        this.alertInfo(`Doador selecionado: ${data.contrato.numero}`);
      }
    });

    modal.present();
  }

  // Método para limpar a seleção do doador (toggle permanece ON)
  limparDoador() {
    this.contratoDoadorSelecionado = null;
    // possuiDoador permanece true — botão "Buscar" reaparece e Salvar fica bloqueado
  }

  // Método chamado quando o toggle muda
  onToggleDoadorChange() {
    if (!this.possuiDoador) {
      // Se desabilitou o toggle, limpa a seleção
      this.contratoDoadorSelecionado = null;
    } else {
      // Se habilitou, abre o modal de busca
      setTimeout(() => this.abrirBuscaDoador(), 300);
    }
  }

  // [ECOENEL-198] Permite valor R$ 0,00 explícito (ex: Embalagem de Vidro HK)
  private arredondar(valor) {
    if (valor === 0) return 0;
    valor =
      valor >= parseFloat("0.005") && valor <= parseFloat("0.009")
        ? parseFloat("0.01")
        : valor;
    return Math.floor(valor * 100) / 100;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem.ts